export default {
  default: 'DEFAULT',
  reversedGradient: 'REVERSED_GRADIENT',
  withoutGradient: 'WITHOUT_GRADIENT',
};
